import React from 'react';
import { Autocomplete, TextField, CircularProgress } from '@mui/material';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getDepartments } from '../redux.actions';

const SelectDepartment = ({ getDepartments, input: { value, onChange } }) => {
    const [departments, setDepartments] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        getDepartments({
            handleSubmit: (data) => {
                setIsLoading(false);
                if (data && data.data) {
                    setDepartments(
                        data.data.map((department) => ({
                            name: department.name,
                            value: department.id
                        }))
                    );
                }
            }
        });
    }, [getDepartments]);

    const selectedDepartment =
        departments.find((d) => String(d.value) === String(value)) || null;

    return (
        <Autocomplete
            size='small'
            sx={{
                minWidth: 158,
                backgroundColor: theme => theme.palette.common.paper
            }}
            componentsProps={{
                paper: {
                    sx: {
                        '& .MuiAutocomplete-option': {
                            fontSize: '12px'
                        }
                    }
                }
            }}
            options={departments}
            getOptionLabel={(option) => option.name || ''}
            value={selectedDepartment}
            onChange={(event, newValue) => {
                onChange(newValue ? newValue.value : '');
            }}
            loading={isLoading}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label='Department'
                    placeholder='Select department'
                    sx={{
                        '& .MuiInputBase-input': { fontSize: '12px' },
                        '& .MuiInputLabel-root': { fontSize: '12px' }
                    }}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {isLoading ? (
                                    <CircularProgress
                                        color='inherit'
                                        size={20}
                                    />
                                ) : null}
                                {params.InputProps.endAdornment}
                            </>
                        )
                    }}
                />
            )}
        />
    );
};

const mapDispatchToProps = (dispatch) => ({
    getDepartments: (payload) => dispatch(getDepartments(payload))
});

export default connect(null, mapDispatchToProps)(SelectDepartment);
